import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {compose} from 'redux';
import App from './components/App';
import reportWebVitals from './reportWebVitals';
import firebaseConfigCoding from './data/firebase-coding.json';
import firebaseConfigDevelop from './data/firebase-develop.json';
import firebaseConfigStaging from './data/firebase-staging.json';
import firebaseConfigRelease from './data/firebase-release.json';
import {store} from './redux/store';
import {initializeApp} from "firebase/app";

declare global {
    interface Window {
        __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: typeof compose;
    }
}

if (window.location.hostname.match(/^pathway-release/) ||
    window.location.hostname === "pathway.flavourworks.co") {
    initializeApp(firebaseConfigRelease);
} else if (window.location.hostname.match(/^pathway-staging/)) {
    initializeApp(firebaseConfigStaging);
} else if (window.location.hostname.match(/^(pathway-develop)/)) {
    initializeApp(firebaseConfigDevelop);
} else {
    initializeApp(firebaseConfigCoding);
}

ReactDOM.render(
	<Provider store={store}>
	    <App/>
	</Provider>,
	document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
